<div class="container">
    <div class="single-column-layout">
        <h1>My Instances</h1>
        <table class="table table-hover">
            <thead>
                <tr>
                    <th style="width: 30px;">&nbsp;</th>
                    <th>Instance</th>
                    <th>Company</th>
                    <th>Status</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                @for (instanceInviteStatus of statuses; track instanceInviteStatus) {
                    <tr>
                        <td style="width: 30px;" [innerHTML]="getHomeIndicator(instanceInviteStatus)">
                        </td>
                        <td>
                            {{ instanceInviteStatus.instanceName }}
                        </td>
                        <td>
                            {{ instanceInviteStatus.companyName }}
                        </td>
                        <td>
                            {{ getStatus(instanceInviteStatus) }}
                        </td>
                        <td>
                            @if (instanceInviteStatus.active === true) {
                                <span>
                                    @if (instanceInviteStatus.invite === false) {
                                        <button (click)="acceptInvitation(instanceInviteStatus.contactId)"
                                                class="ace-btn btn-sm ace-btn btn-primary btn-success">Accept Invitation
                                        </button>
                                    }
                                    @if (instanceInviteStatus.invite === false) {
                                        <button (click)="rejectInvitation(instanceInviteStatus.contactId)"
                                                class="ace-btn btn-sm ace-btn btn-primary btn-danger">Reject Invitation
                                        </button>
                                    }
                                    @if (instanceInviteStatus.invite && instanceInviteStatus.hidden === false && instanceInviteStatus.isHomeInstance === false) {
                                        <button (click)="toggleVisibility(instanceInviteStatus.contactId)"
                                                class="ace-btn btn-sm ace-btn btn-primary">Hide Instance
                                        </button>
                                    }
                                    @if (instanceInviteStatus.invite && instanceInviteStatus.hidden === true) {
                                        <button (click)="toggleVisibility(instanceInviteStatus.contactId)"
                                                class="ace-btn btn-sm ace-btn btn-primary btn-success">Show Instance
                                        </button>
                                    }
                                </span>
                            }
                        </td>
                    </tr>
                }
            </tbody>
        </table>
        @if (changesMade) {
            <div><i class="fa fa-warning text-danger"></i> You will need to <strong>logout for your changes to take
                effect</strong> in the application
            </div>
        }
    </div>
</div>
